// Imagem da campanha: o wa.me só leva texto, então a imagem vai para a área de
// transferência no clique de "Abrir WhatsApp" e o vendedor cola (Ctrl+V) na conversa.

const LADO_MAX = 1600;
const PNG_MAX_BYTES = 1_000_000;

function carregar(src: string): Promise<HTMLImageElement> {
  return new Promise((ok, falha) => {
    const img = new Image();
    img.onload = () => ok(img);
    img.onerror = () => falha(new Error('Não foi possível ler a imagem.'));
    img.src = src;
  });
}

export function lerDataUrl(b: Blob): Promise<string> {
  return new Promise((ok, falha) => {
    const r = new FileReader();
    r.onload = () => ok(r.result as string);
    r.onerror = () => falha(r.error);
    r.readAsDataURL(b);
  });
}

/** Reduz para no máx. 1600px. PNG pequeno fica como está (prints nítidos); o resto vira JPEG. */
export async function prepararImagem(arquivo: File): Promise<string> {
  if (!/^image\/(jpeg|png|webp)$/.test(arquivo.type)) throw new Error('Use uma imagem JPG, PNG ou WebP.');
  const url = URL.createObjectURL(arquivo);
  try {
    const img = await carregar(url);
    const escala = Math.min(1, LADO_MAX / Math.max(img.naturalWidth, img.naturalHeight));
    if (arquivo.type === 'image/png' && escala === 1 && arquivo.size <= PNG_MAX_BYTES) return lerDataUrl(arquivo);
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.naturalWidth * escala);
    canvas.height = Math.round(img.naturalHeight * escala);
    const g = canvas.getContext('2d')!;
    g.fillStyle = '#fff'; // JPEG não tem transparência
    g.fillRect(0, 0, canvas.width, canvas.height);
    g.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/jpeg', 0.85);
  } finally {
    URL.revokeObjectURL(url);
  }
}

/** A área de transferência dos navegadores só aceita image/png de forma confiável. */
export async function paraPng(b: Blob): Promise<Blob> {
  if (b.type === 'image/png') return b;
  const url = URL.createObjectURL(b);
  try {
    const img = await carregar(url);
    const canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    canvas.getContext('2d')!.drawImage(img, 0, 0);
    return await new Promise<Blob>((ok, falha) =>
      canvas.toBlob((r) => (r ? ok(r) : falha(new Error('Falha ao converter a imagem.'))), 'image/png'),
    );
  } finally {
    URL.revokeObjectURL(url);
  }
}

export const podeCopiarImagem = () => typeof ClipboardItem !== 'undefined' && !!navigator.clipboard?.write;

/** Precisa rodar dentro do clique do usuário e com a aba em foco. */
export async function copiarImagem(png: Blob): Promise<boolean> {
  if (!podeCopiarImagem()) return false;
  try {
    await navigator.clipboard.write([new ClipboardItem({ 'image/png': png })]);
    return true;
  } catch {
    return false;
  }
}
